import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import "./HomeSlider.css";

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const HomeSlider = ({ translation }) => {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios("/home_slider/").then((res) => {
      setItems(res.data);
      console.log("DATA:", res.data);
    }).finally(() => setLoaded(true));
  }, []);

  const ua = translation.language === "ua";

  if (loaded && (!items || items.length === 0)) {
    return null;
  }

  return (
    <section className="HomeSlider Container" aria-label={ua ? "Пропозиції" : "Предложения"}>
      <div className={`HomeSlider--frame${loaded ? "" : " loading"}`}>
        <Carousel
          showArrows={true}
          autoPlay={!prefersReducedMotion()}
          swipeable={true}
          infiniteLoop={true}
          showStatus={false}
          showIndicators={true}
          stopOnHover={true}
          showThumbs={false}
          dynamicHeight={false}
          interval={5000}
          transitionTime={450}
          swipeScrollTolerance={5}
          selectedItem={0}
          labels={{
            leftArrow: ua ? "Попередній слайд" : "Предыдущий слайд",
            rightArrow: ua ? "Наступний слайд" : "Следующий слайд",
            item: ua ? "Слайд" : "Слайд"
          }}
        >
          {items.map((slide, idx) => {
            return (
              <div className="HomeSlider--item" key={slide.id || idx}>
                <img className="HomeSlider--image" alt={translation.translateKey(slide, "text")} src={`${process.env.REACT_APP_API}/media/${slide.picture}`} />
                <div className="HomeSlider--item--info">
                  <p className="HomeSlider--item--title">
                    {translation.translateKey(slide, "text")}
                  </p>
                  <Button
                    component={Link}
                    to={"/collections/" + slide.url.split("#").join("/")}
                    variant="contained"
                    className="HomeSlider--cta"
                    disableElevation
                  >
                    {translation.language === "ua"
                      ? "Переглянути пропозицію"
                      : "Посмотреть предложение"}
                  </Button>
                </div>
              </div>
            )
          })}
        </Carousel>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    translation: state.translationReducer,
  };
};

export default connect(mapStateToProps)(HomeSlider);
